const NON_PARTNER_SUBDOMAINS = new Set(["dev", "staging", "preprod", ""]);

export const shouldSkipPartnerCheck = (appSubdomain: string) =>
  NON_PARTNER_SUBDOMAINS.has(appSubdomain);
